const mediaItems = [
  {
    id: 1,
    title: '2026夏季韩漫新番盘点',
    desc: '本季最值得期待的新连载作品一览，从奇幻冒险到校园恋爱，总有一部适合你。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20various%20characters%20in%20different%20genres%20collage%2C%20vibrant%20coral%20and%20golden%20color%20scheme%2C%20clean%20modern%20art%20style%2C%20dynamic%20composition&width=800&height=500&seq=media-01-new-season&orientation=landscape',
    stat: '12.6万次浏览',
  },
  {
    id: 2,
    title: '韩漫入门必看Top 20推荐',
    desc: '从零开始了解韩国漫画，精选20部各类型代表作，新手入坑必读指南。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20bookshelf%20filled%20with%20colorful%20comic%20volumes%2C%20warm%20ambient%20lighting%2C%20cozy%20reading%20room%2C%20soft%20coral%20and%20cream%20tones&width=800&height=500&seq=media-02-top-20&orientation=landscape',
    stat: '8.3万次浏览',
  },
  {
    id: 3,
    title: '那些改编成韩剧的漫画原作',
    desc: '盘点那些被翻拍成热门韩剧的原作漫画，看看原著和改编有什么不同。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20showing%20comic%20panels%20transitioning%20into%20drama%20scene%2C%20split%20screen%20composition%2C%20warm%20coral%20and%20golden%20tones%2C%20cinematic%20quality&width=800&height=500&seq=media-03-adaptation&orientation=landscape',
    stat: '6.9万次浏览',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精彩专题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            深度解读韩漫世界，精选内容专题带你发现更多精彩
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/80 backdrop-blur-sm group-hover:bg-primary-500/90 transition-colors duration-200">
                    <i className="ri-play-circle-fill text-2xl text-foreground-900 group-hover:text-background-50"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1.5 text-foreground-500">
                  <i className="ri-eye-line text-sm"></i>
                  <span className="text-xs">{item.stat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}